import type {TemplateNode} from '@/uptk/core/components/moduleEntity/template/templateTypes';
import type {CalculatorConfig} from '@/uptk/core/components/moduleEntity/calc/calcModel';

export function calculatorNodes(root:TemplateNode):{node:TemplateNode;path:(string|number)[]}[]{
 const result:{node:TemplateNode;path:(string|number)[]}[]=[];
 const visit=(node:TemplateNode,path:(string|number)[])=>{result.push({node,path});if(node.type==='el')node.children.forEach((child,index)=>visit(child,[...path,'children',index]));};
 visit(root,[]);return result;
}
/** Read captured controls, never execute imported JavaScript or infer a value from a label. */
export function capturedCalculator(config:CalculatorConfig,document:Document,prefix:string):CalculatorConfig|undefined{
 const next=structuredClone(config);
 for(const input of next.inputs){
  const controls=Array.from(document.querySelectorAll<HTMLInputElement|HTMLSelectElement>('input[id],select[id]')).filter(control=>control.id.toLowerCase()===prefix+input.field.toLowerCase());
  if(controls.length!==1)return;
  const control=controls[0];
  if(input.control==='select'){
   const option=input.options?.find(option=>String(option.value)===control.value||option.key===control.value);if(!option)return;input.default=option.key;
  }else{
   const literal=control.getAttribute('value');if(literal===null||literal.trim()===''||!Number.isFinite(Number(literal)))return;
   input.default=Number(literal);
   for(const key of ['min','max','step'] as const){const value=control.getAttribute(key);if(value!==null&&value.trim()!==''&&Number.isFinite(Number(value)))input[key]=Number(value);}
   if(input.default<input.min!||input.default>input.max!)return;
  }
 }
 return next;
}
